import React, { useEffect, createElement } from 'react';
import { SocialProof } from './components/SocialProof';
import { PainPoints } from './components/PainPoints';
import { ProductShowcase } from './components/ProductShowcase';
import { WhatYouGet } from './components/WhatYouGet';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { ProBusiness } from './components/ProBusiness';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { DarkCTA } from './components/DarkCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
const HERO_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/v1777951702/hf_20260505_030954_f3af6f54-07ee-4691-a63f-5e12ebacd2ee-Photoroom_amna0c.webp';
const OG_IMG = 'https://cdn.magicpatterns.com/uploads/9uMhQHg3RXXbKPqANDF9n5/hf_20260423_164447_343907b5-95aa-49ff-ba71-eeea9d0be6f6-Photoroom.webp';
const TAGS = ['📄 100% PDF', '⚡ Acceso Inmediato', '🇦🇷 Hecho para Argentina', '🎓 Toda la Carrera', '✅ Sistema Completo', '📚 6 Tomos + 6 Bonos'];
export function App() {
  useEffect(() => {
    const runSeo = () => {
      document.title = 'Megapack Nutrición: Carrera Resuelta — El Sistema Completo para Estudiantes de Nutrición en Argentina';
      document.documentElement.lang = 'es';
      const setMeta = (name: string, content: string, property?: boolean) => {
        const attr = property ? 'property' : 'name';
        let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement;
        if (!el) {
          el = document.createElement('meta');
          el.setAttribute(attr, name);
          document.head.appendChild(el);
        }
        el.content = content;
      };
      const description = 'Dejá de estudiar Nutrición sintiéndote perdido entre apuntes sueltos y materias desordenadas. El Megapack Nutrición Carrera Resuelta es el sistema completo con 6 tomos, 6 bonos y herramientas de organización para ayudarte a entender mejor, rendir más y avanzar en la carrera con claridad. Acceso inmediato.';
      const url = 'https://nutricioncarreraresuelta.com';
      const image = OG_IMG;
      setMeta('description', description);
      setMeta('keywords', 'megapack nutrición, carrera resuelta, estudiar nutrición argentina, material nutrición universitario, sistema de estudio nutrición, organizar carrera nutrición, apuntes nutrición UBA UNLP UNC, dietoterapia argentina, evaluación nutricional, nutrición comunitaria argentina');
      setMeta('robots', 'index, follow');
      setMeta('author', 'Megapack Nutrición: Carrera Resuelta');
      setMeta('viewport', 'width=device-width, initial-scale=1');
      if (!document.querySelector('link[rel="canonical"]')) {
        const canonical = document.createElement('link');
        canonical.rel = 'canonical';
        canonical.href = url;
        document.head.appendChild(canonical);
      }
      setMeta('og:title', 'Megapack Nutrición: Carrera Resuelta — El Sistema Completo para Estudiantes de Nutrición en Argentina', true);
      setMeta('og:description', description, true);
      setMeta('og:image', image, true);
      setMeta('og:url', url, true);
      setMeta('og:type', 'product', true);
      setMeta('og:locale', 'es_AR', true);
      setMeta('og:site_name', 'Megapack Nutrición: Carrera Resuelta™', true);
      setMeta('twitter:card', 'summary_large_image');
      setMeta('twitter:title', 'Megapack Nutrición: Carrera Resuelta — El Sistema Completo para Estudiantes de Nutrición en Argentina');
      setMeta('twitter:description', description);
      setMeta('twitter:image', image);
      if (!document.querySelector('script[data-ld="product"]')) {
        const ld = document.createElement('script');
        ld.type = 'application/ld+json';
        ld.setAttribute('data-ld', 'product');
        ld.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Product',
          name: 'Megapack Nutrición: Carrera Resuelta™',
          description,
          image,
          brand: {
            '@type': 'Brand',
            name: 'Megapack Nutrición: Carrera Resuelta™'
          },
          offers: {
            '@type': 'AggregateOffer',
            lowPrice: '19990',
            highPrice: '34990',
            priceCurrency: 'ARS',
            availability: 'https://schema.org/InStock',
            offerCount: 3
          },
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '512'
          }
        });
        document.head.appendChild(ld);
      }
      if (!document.querySelector('script[data-ld="org"]')) {
        const orgLd = document.createElement('script');
        orgLd.type = 'application/ld+json';
        orgLd.setAttribute('data-ld', 'org');
        orgLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Megapack Nutrición: Carrera Resuelta™',
          url,
          logo: image,
          sameAs: ['https://www.instagram.com/nutricioncarreraresuelta']
        });
        document.head.appendChild(orgLd);
      }
      if (!document.querySelector('script[data-ld="faq"]')) {
        const faqLd = document.createElement('script');
        faqLd.type = 'application/ld+json';
        faqLd.setAttribute('data-ld', 'faq');
        faqLd.textContent = JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [{
            '@type': 'Question',
            name: '¿Qué incluye el Megapack Nutrición: Carrera Resuelta?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'El Nivel 1 incluye 6 tomos con el contenido central de la carrera de Nutrición más 6 bonos de herramientas prácticas. El Nivel 2 suma el Sistema de Estudio y Organización con 2 tomos adicionales. El Nivel 3 incluye todo lo anterior más una Biblioteca Premium de 11 editables para organizar la cursada, parciales, finales y apuntes.'
            }
          }, {
            '@type': 'Question',
            name: '¿Cómo recibo el material?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Todo es 100% digital en formato PDF. Recibís acceso inmediato en tu email dentro de los 5 minutos posteriores a la compra.'
            }
          }, {
            '@type': 'Question',
            name: '¿Tiene garantía?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sí, ofrecemos garantía de 7 días sin preguntas. Si no te sirve, te devolvemos el 100% de tu dinero.'
            }
          }, {
            '@type': 'Question',
            name: '¿Está adaptado a Argentina?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Sí, 100%. Todo el contenido está pensado para estudiantes de la Licenciatura en Nutrición en Argentina, compatible con UBA, UNC, UNLP, USAL y otras universidades con planes de estudio similares.'
            }
          }, {
            '@type': 'Question',
            name: '¿Para qué año de la carrera está pensado?',
            acceptedAnswer: {
              '@type': 'Answer',
              text: 'Para toda la carrera, desde primer año hasta el trabajo final. Cada tomo cubre un eje central de la carrera y los bonos complementan el estudio en todas las etapas.'
            }
          }]
        });
        document.head.appendChild(faqLd);
      }
    };
    if ('requestIdleCallback' in window) {
      ;
      (window as any).requestIdleCallback(runSeo, {
        timeout: 1500
      });
    } else {
      setTimeout(runSeo, 100);
    }
  }, []);
  useEffect(() => {
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      (window as any).fbq('init', '1215304437119773');
      (window as any).fbq('track', 'PageView');
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      s?.parentNode?.insertBefore(t, s);
    }
  }, []);
  return <>
      <noscript data-id="element-0">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1215304437119773&ev=PageView&noscript=1" alt="" data-id="element-1" />
      </noscript>

      <header className="relative flex w-full flex-col items-center justify-center text-center text-gray-900 text-base leading-6 px-5 sm:px-6 py-12 sm:py-16" role="banner" style={{
      backgroundImage: 'linear-gradient(135deg, rgb(240,253,244) 0%, rgb(220,252,231) 30%, rgb(240,253,244) 60%, rgb(247,254,251) 100%)',
      backgroundColor: 'rgb(240,253,244)'
    }} data-id="element-2">
        {/* Badge superior */}
        <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-green-400/30 bg-white/80 px-4 py-1.5 shadow-sm" data-id="element-3">
          <span className="text-xs sm:text-sm font-bold text-green-700 tracking-wide uppercase" data-id="element-4">
            🎓 Para Estudiantes de Nutrición en Argentina · 3 Niveles
            disponibles
          </span>
        </div>

        {/* H1 */}
        <h1 className="font-black tracking-tight text-gray-900 max-w-3xl text-balance sm:text-5xl sm:leading-[1.1] md:text-6xl md:leading-[1.1] m-0 mb-4 text-[27px]" data-id="element-5">
          Toda la carrera de Nutrición en un solo lugar.
          <span className="block text-green-600 mt-2" data-id="element-6">
            Sin buscar más, sin improvisar.
          </span>
        </h1>

        {/* Mockup */}
        <div className="my-6 sm:my-8 w-full max-w-[320px] sm:max-w-[380px] aspect-square relative" data-id="element-7">
          <div className="absolute inset-4 rounded-full z-0 pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(34,197,94,0.30) 0%, rgba(16,185,129,0.10) 50%, transparent 70%)'
        }} data-id="element-8" />
          <div className="relative z-10 w-full h-full" data-id="element-9">
            <img src={HERO_IMG} alt="Megapack Nutrición: Carrera Resuelta — Sistema Completo para Estudiantes de Nutrición Argentina" width="400" height="400" fetchPriority="high" decoding="sync" className="block max-w-full w-full h-auto object-contain" data-id="element-10" />
          </div>
        </div>

        {/* Subtítulo */}
        {/* Subtítulo */}
        {/* Subtítulo */}
        <p className="max-w-xl text-base sm:text-lg font-semibold text-gray-700 leading-7 m-0 mb-4" data-id="element-11">
          El sistema que los mejores estudiantes de Nutrición usan para estudiar
          mejor, organizarse y avanzar en la carrera sin depender de apuntes
          incompletos.{' '}
          <span className="text-gray-900 font-black" data-id="element-12">
            Armado sobre los planes de estudio oficiales de las principales
            universidades de Argentina.
          </span>
        </p>

        {/* Tagline */}
        <p className="max-w-xl text-lg sm:text-xl font-black text-green-600 m-0 mb-4" data-id="element-13">
          "No te falta capacidad. Te falta un sistema claro para estudiar
          Nutrición sin perderte."
        </p>

        {/* 3 niveles badge */}

        {/* Tags */}
        <div className="mb-7 flex max-w-lg flex-wrap items-center justify-center gap-2" data-id="element-14">
          {TAGS.map(tag => <span key={tag} className="whitespace-nowrap bg-white/80 text-xs sm:text-sm font-semibold text-gray-900 leading-5 border border-green-400/30 rounded-full px-3 py-1 shadow-sm" data-id="element-15">
              {tag}
            </span>)}
        </div>

        {/* CTA Button */}
        <a href="#pricing" onClick={() => {
        if (typeof window !== 'undefined' && (window as any).fbq) {
          ;
          (window as any).fbq('track', 'Lead', {
            content_name: 'Hero CTA Click',
            content_category: 'Nutrición Carrera Resuelta'
          });
        }
      }} className="block w-full max-w-sm text-white text-lg sm:text-xl font-black rounded-xl px-6 sm:px-8 py-4 mb-4 no-underline text-center shadow-lg hover:opacity-90 transition-opacity" style={{
        background: 'linear-gradient(135deg, #15803d 0%, #22c55e 50%, #16a34a 100%)'
      }} data-id="element-16">
          🎓 → QUIERO ORDENAR MI CARRERA AHORA
        </a>

        {/* Trust Badges */}
        <div className="flex flex-row flex-wrap items-center justify-center gap-3 sm:gap-4 m-0" data-id="element-17">
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-18">
            🛡️ Garantía 7 días
          </span>
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-19">
            🔒 Pago seguro
          </span>
          <span className="inline-flex items-center gap-1.5 bg-white/80 border border-gray-200 rounded-full px-3 py-1.5 text-xs sm:text-sm text-gray-600 shadow-sm" data-id="element-20">
            💳 Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </header>

      <main data-id="element-21">
        <SocialProof data-id="element-22" />
        <PainPoints data-id="element-23" />
        <ProductShowcase data-id="element-24" />
        <WhatYouGet data-id="element-25" />
        <Bonuses data-id="element-26" />
        <Countdown data-id="element-27" />
        <Pricing data-id="element-28" />
        <ProBusiness data-id="element-29" />
        <Guarantee data-id="element-30" />
        <Testimonials data-id="element-31" />
        <FAQ data-id="element-32" />
        <DarkCTA data-id="element-33" />
      </main>

      <Footer data-id="element-34" />
      <PurchaseNotifications data-id="element-35" />
    </>;
}